import styled, { css } from "styled-components";

const color = ({ $outline, theme }) => {
  if ($outline) return theme.colors.feedbackState.info.default;

  return theme.colors.neutral.white;
};

const backgroundColor = ({ $outline, theme }) => {
  if ($outline) return "transparent";

  return theme.colors.feedbackState.info.default;
};

const hoverBackgroundColor = ({ $outline, theme }) => {
  if ($outline) return theme.colors.feedbackState.info.disabled;

  return theme.colors.feedbackState.info.hover;
};

const outline = ({ $outline, theme }) => {
  if ($outline) return `2px solid ${theme.colors.feedbackState.info.default} `;

  return "none";
};

const focusBackgroundColor = ({ $outline, theme }) => {
  if ($outline) return "transparent";

  return theme.colors.feedbackState.info.default;
};

const focusOutline = ({ theme }) => {
  return `4px solid ${theme.colors.feedbackState.info.hover}`;
};

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
  margin: 10px;
`;

export const InfoButtonStructure = css`
  color: ${color};
  background-color: ${backgroundColor};
  border: ${outline};

  &:hover:not([disabled]) {
    background-color: ${hoverBackgroundColor};
  }

  &:focus {
    background-color: ${focusBackgroundColor};
    outline: ${focusOutline};
  }
`;
